const SettingAssessmentKey = Object.freeze({
    Pepa: 'pepa',
    Know: 'know',
    Head: 'head',
    Me: 'moi',
    Custom: 'custom',
})

// MARK: - Assessment Pepa

const assessment_criteria1_pepa = "Show" //"Performance";
const assessment_criteria2_pepa = "Know" //"Social / Development";
const assessment_criteria3_pepa = "Grow" //"Competition";

// MARK: - Assessment Know, Show, Grow

const assessment_criteria1_know = "Know";
const assessment_criteria2_know = "Show";
const assessment_criteria3_know = "Grow";

// MARK: - Assessment Head, Heart, Hands

const assessment_criteria1_head = "Head";
const assessment_criteria2_head = "Heart";
const assessment_criteria3_head = "Hands";

// MARK: - Assessment Physical Me

const assessment_criteria1_moi = "Physical Me";
const assessment_criteria2_moi = "Leading Me";
const assessment_criteria3_moi = "Healthy Me";
const assessment_criteria4_moi = "Thinking Me";
const assessment_criteria5_moi = "Creative Me";

// MARK: - Assessment Grades Primary

const assessment_grade1_pepa = "Bronze";
const assessment_grade2_pepa = "Silver";
const assessment_grade3_pepa = "Gold";
const assessment_grade4_pepa = "Greater Depth";

// MARK: - Assessment Grades Know, Show, Grow

const assessment_grade1_know = "Emerging";
const assessment_grade2_know = "Acquiring";
const assessment_grade3_know = "Developing";
const assessment_grade4_know = "Securing";
const assessment_grade5_know = "Thriving";

// MARK: - Assessment Grades  Head, Heart, Hands

const assessment_grade1_head = "Emerging";
const assessment_grade2_head = "Acquiring";
const assessment_grade3_head = "Developing";
const assessment_grade4_head = "Securing";
const assessment_grade5_head = "Thriving";

// MARK: - Assessment Grades Physical Me

const assessment_grade1_moi = "Emerging";
const assessment_grade2_moi = "Developing";
const assessment_grade3_moi = "Securing";
const assessment_grade4_moi = "Mastering";


class SettingAssessment {


    static from(object) {
        try {
            return new SettingAssessment(object);
        } catch (err) {
            console.log("error - no criteria", err);
            return new SettingAssessment("pepa");
        }
    }


    constructor(initializer) {
        this.key = initializer;
    }

    // Criteria settings

    get criteria1() {
        switch (this.key) {
            case "know":
                return assessment_criteria1_know
            case "head":
                return assessment_criteria1_head;
            case "moi": 
                return assessment_criteria1_moi;          
            default: 
                return assessment_criteria1_pepa;
        }
    }

    get criteria2() {
        switch (this.key) {
            case "know":
                return assessment_criteria2_know
            case "head":
                return assessment_criteria2_head;
            case "moi": 
                return assessment_criteria2_moi;    
            default: 
            return assessment_criteria2_pepa;
        }
    }

    get criteria3() {
        switch (this.key) {
            case "know":
                return assessment_criteria3_know
            case "head":
                return assessment_criteria3_head;
            case "moi": 
                return assessment_criteria3_moi;    
            default: 
         return assessment_criteria3_pepa;

        }
    }

    get criteria4() {
        switch (this.key) {
            case "moi":
                return assessment_criteria4_moi;
            default:
                 return undefined;

        }
    }

    get criteria5() {
        switch (this.key) {
            case "moi":
                return assessment_criteria5_moi;
            default: 
            return undefined;

        }
    }

    // Grade settings

    get grade1() {
        switch (this.key) {
            case "know":
                return assessment_grade1_know
            case "head":
                return assessment_grade1_head;
            case "moi": 
                return assessment_grade1_moi;    
            default: 
            return assessment_grade1_pepa;
        }
    }

    get grade2() {
        switch (this.key) {
            case "know":
                return assessment_grade2_know
            case "head":
                return assessment_grade2_head;
            case "moi": 
                return assessment_grade2_moi;   
            default: 
            return assessment_grade2_pepa;
        }
    }

    get grade3() {
        switch (this.key) {
            case "know":
                return assessment_grade3_know
            case "head":
                return assessment_grade3_head;
            case "moi": 
                return assessment_grade3_moi;   
            default: 
            return assessment_grade3_pepa;
        }
    }

    get grade4() {
        switch (this.key) {
            case "know":
                return assessment_grade4_know
            case "head":
                return assessment_grade4_head;
            case "moi": 
                return assessment_grade4_moi;   
            default: 
            return assessment_grade4_pepa;
        }
    }

    get grade5() {
        switch (this.key) {
            case "know":
                return assessment_grade5_know
            case "head":
                return assessment_grade5_head;
            default: 
            return undefined;
        }
    }

    get grade6() {
        return undefined;
    }

    get grade7() {
        return undefined;
    }

    get grade8() {
        return undefined;
    }

    get grade9() {
        return undefined;
    }

}


export { SettingAssessment, SettingAssessmentKey };